/** eslint-disable react/display-name */
import * as React from 'react';
import ModalIntegration from './ModalIntegration';
import { useLocation, useNavigate } from 'react-router-dom';
import { showAlert } from 'components/Alert';
import { bukalapakAuthorize } from 'api/marketPlaces';
import { useAppStore } from 'stores/appStore';
import Connected from 'components/Connected/Connected';

function getSearchQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const withModalIntegration = <P extends object>(WrappedComponent: React.ComponentType<P>, connected: boolean = false) => {
  const WithModal = (props) => {
    const params = getSearchQuery();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [data, setData] = React.useState<unknown>(null);
    const urlParams = React.useRef({
      bukalapakCode: null,
      integrated: null,
    })
    const { setShowConnectedPopup } =
        useAppStore();

    const openModal: (data: unknown, isRedirect: boolean) => void = (chData, isRedirect = true) => {
      setIsOpen(true);
      if (isRedirect) setData(chData);
    };
    const closeModal = () => setIsOpen(false);

    const integratedNotification = async () => {
        if (urlParams.current.integrated && !urlParams.current.bukalapakCode) {
          setShowConnectedPopup(true);
          params.delete('integrated');
          navigate('/');
        }
    
        if (urlParams.current.bukalapakCode) {
          try {
            const authorizeRes = await bukalapakAuthorize(urlParams.current.bukalapakCode);
            if (authorizeRes.data.error) {
              showAlert('error', authorizeRes.data.error.error_description, 5000);
              navigate('/');
            } else {
              setShowConnectedPopup(true);
              window.location.reload()
            }
          } catch (error) {
            showAlert('error', error.message, 5000);
            navigate('/');
          }
        }
      };

    React.useEffect(() => {
        const initiateFlag = () => {
          const integratedParams = params.get('integrated');
          const bukalapakCode = params.get('?code');
          urlParams.current.bukalapakCode = bukalapakCode;
          urlParams.current.integrated = integratedParams;
        };
        
        initiateFlag();
        integratedNotification();
      }, []);

    return (
      <>
        <WrappedComponent {...props} openModal={openModal} />
        <ModalIntegration open={isOpen} onClose={closeModal} chData={data} isConnected={connected} /> 
        <Connected />
        {/* <ModalForm open={isOpen} onClose={closeModal} /> */}
      </>
    );
  };

  return WithModal;
};

export default withModalIntegration;
